import { Component, Input, OnInit } from "@angular/core";
import { format, render, cancel, register } from "timeago.js";
import { ExcelService } from "../../@core/utils/excel.service";

@Component({
  selector: "ngx-view-button-export-excel",
  styleUrls: ["./view-button-export-excel.component.scss"],
  templateUrl: "./view-button-export-excel.component.html",
})
export class ViewButtonExportExcelComponent implements OnInit {
  @Input() fileName?: string;
  @Input() source?: any;

  constructor(private excelService: ExcelService) {}

  ngOnInit(): void {}

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.source, this.fileName);
  }
}
